import FacebookLogin from './facebook-login';

export default FacebookLogin;
